/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_Created_ByInputs */

const en_tables_rule_sets_created_by = /** @type {(inputs: Tables_Rule_Sets_Created_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Created By`)
};

const de_tables_rule_sets_created_by = /** @type {(inputs: Tables_Rule_Sets_Created_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt von`)
};

/**
* | output |
* | --- |
* | "Sets Created By" |
*
* @param {Tables_Rule_Sets_Created_ByInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_created_by = /** @type {((inputs?: Tables_Rule_Sets_Created_ByInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_Created_ByInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_created_by(inputs)
	return de_tables_rule_sets_created_by(inputs)
});